import {useRef} from 'react';
import RankingInfo from './RankingInfo';
import ContentCardV4 from '../../../common/component/ContentCardV4';
import useIntersection from '../../../common/hook/useIntersection';
import useSplitAdultBadgeList from '../../../common/hook/useSplitAdultBadgeList';
import {IRankingContent} from '../type';

interface IProps {
  content: IRankingContent;
  index: number;
  onSendContentViewImp?: (id: number) => void;
  onClick?: (id: number, sid: string) => void;
}

export default function RankingContentCard({
  content,
  index,
  onSendContentViewImp,
  onClick,
}: IProps) {
  const contentCardRef = useRef<HTMLDivElement>(null);
  const {id, sid, ranking, delta, badges} = content;
  const {adultBadges, otherBadges} = useSplitAdultBadgeList(badges);

  useIntersection({
    targetRef: contentCardRef,
    onIntersection: isIntersecting => {
      isIntersecting && onSendContentViewImp?.(id);
    },
  });

  return (
    <ContentCardV4
      ref={contentCardRef}
      content={{...content, badges: otherBadges}}
      cardInfoClassName="!bottom-34"
      additionalElement={
        <RankingInfo ranking={ranking} delta={delta} badges={adultBadges} />
      }
      onClick={() => onClick?.(id, sid)}
      index={index}
    />
  );
}
